import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

const OrderActions = ({
  canCaptureFunds,
  canConfirmPickup,
  canConfirmSendAndPayLater,
  editing,
  isProcessing,
  onCaptureFundsClick,
  onConfirmPickupClick,
  onConfirmSendAndPayLaterClick,
  recalculating = false,
}) => (
  <div className="d-flex justify-content-center flex-wrap gap-2">
    {canCaptureFunds && (
      <Button
        variant="success"
        onClick={onCaptureFundsClick}
        className="mt-3"
        disabled={editing || isProcessing || recalculating}
      >
        Realizar Cobro
      </Button>
    )}
    {canConfirmPickup && (
      <Button
        variant="primary"
        onClick={onConfirmPickupClick}
        className="mt-3"
        disabled={editing || isProcessing}
      >
        Confirmar Recolección
      </Button>
    )}
    {canConfirmSendAndPayLater && (
      <Button
        variant="primary"
        onClick={onConfirmSendAndPayLaterClick}
        className="mt-3"
        disabled={editing || isProcessing}
      >
        Confirmar Envío
      </Button>
    )}
  </div>
);

export default memo(OrderActions);
